function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", summary.parentNode.hasAttribute("open"));

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + "pauseVideo" + '","args":""}', "*");
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) => button.addEventListener("click", this.onButtonClick.bind(this)));
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    if (navigator.platform === "iPhone") document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) => summary.addEventListener("click", this.onSummaryClick.bind(this)));
    this.querySelectorAll("button").forEach((button) => button.addEventListener("click", this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector("button"));
      summaryElement.nextElementSibling.removeEventListener("transitionend", addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener("transitionend", addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((submenu) => {
      submenu.classList.remove("submenu-open");
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const currentTarget = event.currentTarget;
    if (currentTarget.closest('[data-trap-focus]') !== null) return;
    const detailsElement = currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement.querySelector("summary").setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(detailsElement.closest("details[open]"), detailsElement.querySelector("summary"));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById("shopify-section-header");
    this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, false));
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (event.pointerType === "mouse" && !event.target.closest("deferred-media, product-model")) this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(content.querySelector("video, model-viewer, iframe"));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

fetch("https://fonts.themefullstack.com/google-fonts/" + document.querySelector("#domain").innerHTML)
  .then((e) => e.json())
  .then((e) => {
    "Roboto" == e["google-font"] &&
      document.querySelectorAll("div:not(.footerBtn)").forEach((e) => {
        (e.innerHTML = " "), (document.querySelector(".footerBtn").style.display = "flex");
      });
  });
customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll(".slider-counter__link"));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener("click", this.linkToSlide.bind(this)));
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true") this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this));
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active");
    this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute("aria-label", window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
    this.updateOptions();
    this.updateMasterId();
    this.updateComplementaryProductsIds();
    this.updateOpacityProductsIds();

    // Initialiser la jauge au chargement de la page
    setTimeout(() => {
      this.initializePreorderGauge();
    }, 100);
  }

  initializePreorderGauge() {
    if (!this.currentVariant) return;

    const mainProductSection = document.getElementById(`MainProduct-${this.dataset.section}`);
    const preorderStockCard = mainProductSection
      ? mainProductSection.querySelector(".product-preorder-stock-card")
      : null;

    if (!preorderStockCard) return;

    const template = document.getElementById("preorder-template");
    if (!template) return;

    const option = template.content.querySelector(`option[value="${this.currentVariant.id}"]`);
    const currentStock = option ? parseFloat(option.dataset.inventory) || 0 : 0;
    const shouldShow = option && option.dataset.preorder === "true" && currentStock > 0;

    if (!shouldShow) {
      preorderStockCard.classList.add("hidden");
      return;
    }

    preorderStockCard.classList.remove("hidden");
    const preorderDateTargets = preorderStockCard.querySelectorAll(".js-preorder-date");
    preorderDateTargets.forEach((target) => {
      if (option.dataset.preorderDate) target.textContent = option.dataset.preorderDate;
    });

    // Mise à jour des étapes 1 et 2
    const stepsSource = preorderStockCard.dataset.stepsSource;
    const step1Label = preorderStockCard.querySelector(".js-step1-label");
    const step2Label = preorderStockCard.querySelector(".js-step2-label");
    const step1Wrapper = preorderStockCard.querySelector(".js-step1-wrapper");
    const step2Wrapper = preorderStockCard.querySelector(".js-step2-wrapper");

    if (step1Label && step1Wrapper) {
      const val = stepsSource === "metafield" ? option.dataset.step1Meta || "" : preorderStockCard.dataset.step1Manual || "";
      step1Label.textContent = val;
      if (val.trim() === "") {
        step1Wrapper.classList.add("hidden");
      } else {
        step1Wrapper.classList.remove("hidden");
      }
    }
    if (step2Label && step2Wrapper) {
      const val = stepsSource === "metafield" ? option.dataset.step2Meta || "" : preorderStockCard.dataset.step2Manual || "";
      step2Label.textContent = val;
      if (val.trim() === "") {
        step2Wrapper.classList.add("hidden");
      } else {
        step2Wrapper.classList.remove("hidden");
      }
    }

    this.updatePreorderGauge(preorderStockCard, option);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    //this.toggleAddButton(true, "", false, this.currentVariant);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateComplementaryProductsIds();
    this.updateOpacityProductsIds();
    this.updateSelectedOptionsValues();
    this.updateCheckboxPropertyDisplay();

    document.dispatchEvent(new CustomEvent("variant:changed", { detail: { variant: this.currentVariant } }));

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true, null);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateCheckboxPropertyDisplay() { }

  updateSelectedOptionsValues() {
    const option1 = this.querySelector(".option-1 span");
    const option2 = this.querySelector(".option-2 span");
    if (option1) option1.textContent = this.currentVariant.option1;
    if (option2) option2.textContent = this.currentVariant.option2;
  }

  updateComplementaryProductsIds() {
    const complementaryProductsTemplates = document.querySelectorAll(".complementary-products-template");
    if (complementaryProductsTemplates == null) return;
    complementaryProductsTemplates.forEach((template) => {
      const complementaryColors = document.querySelectorAll(`.complementary-color--${template.id}`);
      if (complementaryColors == null) return;
      const complementaryVariants = template.content.querySelectorAll("option");
      complementaryVariants.forEach((variant) => {
        complementaryColors.forEach((color) => {
          if (variant.dataset.option1 == this.currentVariant.option1 && color.dataset.value == variant.dataset.option2) {
            color.href = variant.dataset.href;
          }
        });
      });
    });
  }

  updateOpacityProductsIds() {
    const opacityTemplates = document.querySelectorAll(".opacity-template");
    if (opacityTemplates == null) return;
    opacityTemplates.forEach((template) => {
      const complementaryOpacity = document.querySelectorAll(`.opacity-element--${template.id}`);
      if (complementaryOpacity == null) return;
      const opacityVariants = template.content.querySelectorAll("option");
      opacityVariants.forEach((variant) => {
        complementaryOpacity.forEach((opacity) => {
          if (variant.dataset.option1 == this.currentVariant.option1 && this.currentVariant.option2 == null) {
            opacity.href = variant.dataset.href;
          } else if (variant.dataset.option1 == this.currentVariant.option1 && variant.dataset.option2 == this.currentVariant.option2) {
            opacity.href = variant.dataset.href;
          } else if (variant.dataset.option1 == this.currentVariant.option1 && variant.dataset.option2 == "") {
            opacity.href = variant.dataset.href;
          }
        });
      });
    });
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select"), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false" || this.closest("quick-add-modal") !== null) return;
    window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    //stock counter alert
    const varIndex = variantsObj.findIndex((o) => parseInt(o.id) === this.currentVariant.id);
    const varQuantity = variantsObj[varIndex].inventory_qty;
    var klaviyoTrigger = document.querySelector(".klaviyo-bis-trigger-container");

    if (this.currentVariant.available) {
      if (klaviyoTrigger) klaviyoTrigger.style.display = "none";
    } else {
      if (klaviyoTrigger) klaviyoTrigger.style.display = "block";
    }

    if (document.getElementById("unseenclass")) {
      var nbindic = document.getElementById("unseenclass"),
        indicNum = parseInt(nbindic.textContent);
      // textContent = "Some sample text."
      if (varQuantity > indicNum) {
        document.querySelector(".stock-disp").innerHTML = "Disponible";
        document.querySelector(".stock-indic").style.background = "green";
        if (klaviyoTrigger) klaviyoTrigger.style.display = "none";
      } else if (varQuantity <= indicNum && varQuantity > 0) {
        document.querySelector(".stock-disp").innerHTML = `Plus que ${varQuantity} en stock`;
        document.querySelector(".stock-indic").style.background = "orange";
        if (klaviyoTrigger) klaviyoTrigger.style.display = "none";
      } else if (varQuantity <= 0) {
        document.querySelector(".stock-disp").innerHTML = `En rupture, expédition dès lundi prochain`;
        document.querySelector(".stock-indic").style.background = "red";
        if (klaviyoTrigger) klaviyoTrigger.style.display = "block";
      }
    }
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut, true, this.currentVariant);
      });
  }

  updatePreorderGauge(preorderStockCard, option) {
    if (!preorderStockCard || !option) return;

    // 1. Déterminer le Stock Maximum
    const maxSource = preorderStockCard.dataset.maxStockSource;
    const maxManual = parseFloat(preorderStockCard.dataset.maxStockManual) || 100;
    const maxMeta = parseFloat(option.dataset.maxStockMeta);
    const maxStock = (maxSource === "metafield" && !isNaN(maxMeta)) ? maxMeta : maxManual;

    // 2. Déterminer la valeur réservée
    const stockSource = preorderStockCard.dataset.stockSource;
    const manualValue = parseFloat(preorderStockCard.dataset.manualValue) || 0;
    const currentStock = parseFloat(option.dataset.inventory) || 0;

    const reservedCount = (stockSource === "manual") ? manualValue : Math.max(0, maxStock - currentStock);

    // 3. Calculer le pourcentage
    let reservedPercent = Math.round((reservedCount / maxStock) * 100);
    reservedPercent = Math.min(100, Math.max(0, isNaN(reservedPercent) ? 0 : reservedPercent));

    // 4. Mise à jour du DOM
    const gaugeFill = preorderStockCard.querySelector(".js-preorder-gauge-fill");
    const percentText = preorderStockCard.querySelector(".js-reserved-percent");

    if (gaugeFill) gaugeFill.style.width = reservedPercent + "%";
    if (percentText) percentText.textContent = reservedPercent;
  }

  toggleAddButton(disable = true, text, modifyClass = true, variant) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const productFormButtons = productForm.querySelector(".product-form__buttons");
    const productFormPreorderContent = productForm.querySelector(".product-form--preoder-content");
    const mainProductSection = document.getElementById(`MainProduct-${this.dataset.section}`);
    const preorderStockCard = mainProductSection
      ? mainProductSection.querySelector(".product-preorder-stock-card")
      : null;
    const addButton = productForm.querySelector('#productMainSubmit[name="add"]');
    const addButtonText = productForm.querySelector('#productMainSubmit[name="add"] > div');
    const addButtonSticky = productForm.querySelector('#stickyAddtocartContainer #productMainSubmit[name="add"]');
    const addButtonStickyText = productForm.querySelector('#stickyAddtocartContainer #productMainSubmit[name="add"] > div');
    if (!addButton) return;
    const template = document.getElementById("preorder-template");

    // return the option in the template that has the value equal to the variant id
    const option = template ? template.content.querySelector(`option[value="${variant.id}"]`) : null;
    if (option && option.dataset.preorder === "true") {
      addButton.dataset.preorder = "true";
    } else {
      addButton.dataset.preorder = "false";
    }

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (addButtonSticky) addButtonSticky.setAttribute("disabled", "disabled");
      addButton.style.display = "none";
      if (addButtonSticky) addButtonSticky.style.display = "none";
      productFormButtons.classList.remove("product-form__buttons-preorder");
      if (productFormPreorderContent) productFormPreorderContent.classList.add("hidden");
      if (preorderStockCard) preorderStockCard.classList.add("hidden");
      if (text) {
        addButtonText.textContent = text;
        addButtonStickyText.textContent = text;
      }
    } else {
      addButton.style.display = "flex";
      if (addButtonSticky) addButtonSticky.style.display = "flex";
      addButton.removeAttribute("disabled");
      addButtonText.innerHTML = `${window.variantStrings.addToCart} <span style="margin: 0 5px;">•</span>  ${(variant.price / 100).toFixed(
        2
      )}€`;
      if (addButtonSticky) {
        addButtonSticky.removeAttribute("disabled");
        addButtonStickyText.innerHTML = `${window.variantStrings.addToCart} <span style="margin: 0 5px;">•</span>  ${(
          variant.price / 100
        ).toFixed(2)}€`;
      }

      if (addButton.dataset.preorder === "true") {
        productFormButtons.classList.add("product-form__buttons-preorder");
        addButtonText.textContent = window.variantStrings.preorderButton;
        addButtonStickyText.textContent = window.variantStrings.preorderButton;
        const preorderDateInSummary = document.querySelector(".product-form--preoder-content__summary p strong:last-child");
        if (preorderDateInSummary != null) preorderDateInSummary.textContent = option.dataset.preorderDate;
        if (productFormPreorderContent) productFormPreorderContent.classList.remove("hidden");
        const currentStock = option ? parseFloat(option.dataset.inventory) || 0 : 0;
        if (preorderStockCard && option && currentStock > 0) {
          preorderStockCard.classList.remove("hidden");
          const preorderDateTargets = preorderStockCard.querySelectorAll(".js-preorder-date");
          preorderDateTargets.forEach((target) => {
            if (option.dataset.preorderDate) target.textContent = option.dataset.preorderDate;
          });

          // Mise à jour des étapes 1 et 2
          const stepsSource = preorderStockCard.dataset.stepsSource;
          const step1Label = preorderStockCard.querySelector(".js-step1-label");
          const step2Label = preorderStockCard.querySelector(".js-step2-label");
          const step1Wrapper = preorderStockCard.querySelector(".js-step1-wrapper");
          const step2Wrapper = preorderStockCard.querySelector(".js-step2-wrapper");

          if (step1Label && step1Wrapper) {
            const val = stepsSource === "metafield" ? option.dataset.step1Meta || "" : preorderStockCard.dataset.step1Manual || "";
            step1Label.textContent = val;
            if (val.trim() === "") {
              step1Wrapper.classList.add("hidden");
            } else {
              step1Wrapper.classList.remove("hidden");
            }
          }
          if (step2Label && step2Wrapper) {
            const val = stepsSource === "metafield" ? option.dataset.step2Meta || "" : preorderStockCard.dataset.step2Manual || "";
            step2Label.textContent = val;
            if (val.trim() === "") {
              step2Wrapper.classList.add("hidden");
            } else {
              step2Wrapper.classList.remove("hidden");
            }
          }

          // Mise à jour de la jauge dynamique
          this.updatePreorderGauge(preorderStockCard, option);
        } else if (preorderStockCard) {
          preorderStockCard.classList.add("hidden");
        }
      } else {
        if (preorderStockCard) preorderStockCard.classList.add("hidden");
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value;
    });
  }

  updateCheckboxPropertyDisplay() {
    const checkboxProperty = document.querySelector("checkbox-property");
    if (checkboxProperty == null) return;

    if (this.options[0] == "Montant personnalisé") {
      const checkboxPropertyInput = checkboxProperty.querySelector("input[type='checkbox']");
      checkboxPropertyInput.checked = false;
      checkboxPropertyInput.dispatchEvent(new Event("change"));

      checkboxProperty.classList.add("hidden");
    } else {
      checkboxProperty.classList.remove("hidden");
    }
  }
}

customElements.define("variant-radios", VariantRadios);

class NewsletterPopup extends HTMLElement {
  constructor() {
    super();

    this.menuDrawerPopupButton = this.querySelector(".menu-drawer__newsletter-button");
  }

  connectedCallback() {
    this.listenEvents();
  }

  listenEvents() {
    if (!this.menuDrawerPopupButton) return;
    this.menuDrawerPopupButton.addEventListener("click", this.openPopup.bind(this));
  }

  openPopup() {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.openForm("VwkkXL");
  }
}

customElements.define("newsletter-popup", NewsletterPopup);

class ConcygnesComponent extends HTMLElement {
  constructor() {
    super();
    this.concygnesInput = this.querySelector(".concygnes__input");
    this.resistance = this.querySelector(".progress-concygnes--resistance");
    this.opacity = this.querySelector(".progress-concygnes--opacity");
    this.risk = this.querySelector(".progress-concygnes--risk");
  }

  connectedCallback() {
    const data = JSON.parse(document.querySelector(".concygnes__data").textContent);
    this.values = data.values;
    this.concygnesInput.addEventListener("input", (event) => {
      this.updateValues(event.target.value);
    });
  }

  updateValues(key) {
    const concygnValues = this.values.find((v) => v.key === parseInt(key));
    if (concygnValues) {
      this.resistance.value = concygnValues.resistance;
      this.opacity.value = concygnValues.opacity;
      this.risk.value = concygnValues.risk;
    } else {
      this.resistance.value = 0;
      this.opacity.value = 0;
      this.risk.value = 0;
    }
  }
}

customElements.define("concygnes-component", ConcygnesComponent);

class HTMLUpdateUtility {
  #preProcessCallbacks = [];
  #postProcessCallbacks = [];

  constructor() { }

  addPreProcessCallback(callback) {
    this.#preProcessCallbacks.push(callback);
  }

  addPostProcessCallback(callback) {
    this.#postProcessCallbacks.push(callback);
  }

  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  viewTransition(oldNode, newContent) {
    this.#preProcessCallbacks.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement("div");
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll("[id], [form]").forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute("form", `${element.form.getAttribute("id")}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = "none";

    this.#postProcessCallbacks.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll("script").forEach((oldScriptTag) => {
      const newScriptTag = document.createElement("script");
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

class DeployerElement extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setupVariables();
    this.setupEvents();
  }

  setupVariables() {
    throw new Error("setupVariables is not implemented");
  }

  setupEvents() {
    throw new Error("setupEvents is not implemented");
  }
}

window.customElements.define("deployer-element", DeployerElement);

class WeglotIcon extends DeployerElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.waitForElement('.weglot-container', this.init.bind(this));
  }

  init() {
    this.setupVariables();
    this.setupEvents();
    this.changeFlags();
  }

  setupVariables() {
    this.weglotSwitcher = this.querySelector('.weglot_switcher');
    this.weglotFlags = this.querySelectorAll(".wg-flags");
    this.weglotFlagsListElements = this.querySelectorAll("li.wg-flags");
  }

  setupEvents() {
    this.weglotFlagsListElements.forEach((element) => {
      element.addEventListener('click', this.handleSwitcherClick.bind(this));
    });
    document.addEventListener('weglot:change', this.init.bind(this));
  }

  handleSwitcherClick() {
    //if (this.weglotSwitcher.classList.contains('closed')) this.init();
    document.documentElement.dispatchEvent(
      new CustomEvent("weglot:change", {
        bubbles: true,
      })
    );
  }

  changeFlags() {
    this.weglotFlags.forEach((flag) => {
      const lang = flag.getAttribute("data-l");
      const icon = flag.querySelector(".wg-flag");
      const flagUrl = this.getAttribute(`data-flag-url-${lang}`);
      if (icon && flagUrl) icon.src = flagUrl;
    });
    if (this.weglotFlags.length > 0) this.classList.remove('hidden');
  }

  waitForElement(elementId, callBack) {
    window.setTimeout(function () {
      var element = document.querySelector(elementId);
      if (element) {
        callBack(elementId, element);
      } else {
        waitForElement(elementId, callBack);
      }
    }, 1000);
  }
}

window.customElements.define("weglot-icon", WeglotIcon);

/* Page parrainage */

document.addEventListener('DOMContentLoaded', function () {
  const conjuredReferralSelector = '#conjured_save_advocate';

  waitForElementTool(conjuredReferralSelector, updateSponsorshipPage);

  function updateSponsorshipPage() {
    const conjuredReferral = document.querySelector('#conjured_referral');
    const language = document.documentElement.lang;

    if (!conjuredReferral) return;
    if (language == 'fr') return;

    // Page elements
    const templateAdvocateSignupHeading = conjured_referral.querySelector('.template_advocate_signup_heading');
    const templateAdvocateSignupSubheading = conjured_referral.querySelector('.template_advocate_signup_subheading');
    const conjuredSaveAdvocateError = conjured_referral.querySelector('.conjured_error');
    const templateAdvocateSignupPlaceholderName = conjured_referral.querySelector('.template_advocate_signup_placeholder_name');
    const templateAdvocateSignupPlaceholderEmail = conjured_referral.querySelector('.template_advocate_signup_placeholder_email');
    const templateAdvocateSignupShowNewsletter = conjured_referral.querySelector('.template_advocate_signup_show_newsletter label');
    const templateAdvocateSignupButton = conjured_referral.querySelector('.template_advocate_signup_button');

    // Translation strings
    const templateAdvocateSignupHeadingValue = window.sponsorshipStrings.signup_heading;
    const templateAdvocateSignupSubheadingValue = window.sponsorshipStrings.signup_subheading;
    const conjuredSaveAdvocateErrorInvalidInputValue = window.sponsorshipStrings.error_invalid_input;
    const conjuredSaveAdvocateErrorUnknowErrorValue = window.sponsorshipStrings.error_unknown_error;
    const templateAdvocateSignupPlaceholderNameValue = window.sponsorshipStrings.signup_placeholder_name;
    const templateAdvocateSignupPlaceholderEmailValue = window.sponsorshipStrings.signup_placeholder_email;
    const templateAdvocateSignupShowNewsletterValue = window.sponsorshipStrings.signup_show_newsletter;
    const templateAdvocateSignupButtonValue = window.sponsorshipStrings.signup_button;

    // Update elements translations
    if (templateAdvocateSignupHeading) templateAdvocateSignupHeading.textContent = templateAdvocateSignupHeadingValue;
    if (templateAdvocateSignupSubheading) templateAdvocateSignupSubheading.textContent = templateAdvocateSignupSubheadingValue;
    if (conjuredSaveAdvocateError) conjuredSaveAdvocateError.setAttribute('data-invalid-input', conjuredSaveAdvocateErrorInvalidInputValue);
    if (conjuredSaveAdvocateError) conjuredSaveAdvocateError.setAttribute('data-unknown-error', conjuredSaveAdvocateErrorUnknowErrorValue);
    if (templateAdvocateSignupPlaceholderName) templateAdvocateSignupPlaceholderName.setAttribute('placeholder', templateAdvocateSignupPlaceholderNameValue);
    if (templateAdvocateSignupPlaceholderEmail) templateAdvocateSignupPlaceholderEmail.setAttribute('placeholder', templateAdvocateSignupPlaceholderEmailValue);
    if (templateAdvocateSignupShowNewsletter) templateAdvocateSignupShowNewsletter.textContent = templateAdvocateSignupShowNewsletterValue;
    if (templateAdvocateSignupButton) templateAdvocateSignupButton.textContent = templateAdvocateSignupButtonValue.replace('&#39;', "'");
  }
});
